module.exports = __webpack_public_path__ + "24ac66810aeb492e27b40802cce2cdb2.svg";